export function makeCmsUrl(server) {
    const M = (j) => server + '/backoffice/tool' + j;
    return {
        getBasicList: M('/api/config/basic/all'),
        getModelList: M('/api/config/group/list'),
        putAddModelItem: M('/api/config/group'),
        deleteModelItem: M('/api/config-group'),
        postGetConfigList: M('/api/config/list'),
        putImportConfig: M('/api/config'),
        deleteConfig: M('/api/config/key'),
        getConfigDetail: M('/api/config/key'),
        putAddConfigDetail: M('/api/config'),
        putUpdateConfig: M('/api/config/key'),
    };
}
